export const UPPY_TRANSITION_MS = 1000;
export const ASSET_MANAGER_TRANSITION_MS = 500;
export const UPPY_PROGRESS_PERCENTAGE = 70 / 100;
export const OPACITY_TRANSITION_MS = 250;
export const PROGRESS_SIZE_PERCENTAGE = 80 / 100;
